export default __webpack_public_path__ + "static/media/greyStepIncomplete.614cf59e.svg";